<app-lfsa-card [innTemplate]="enviarTemplate" [titulo]="'Nivel 1'">
</app-lfsa-card>

<ng-template #enviarTemplate>
    <br>
    <form [formGroup]="formulario" novalidate class="form-group">
        <div class="row">
            <div class="col-md-6">
                <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get(modelo.menuSuperior)" [placeholder]="'Ingrese el nombre del Menú nivel 1 '"
                    formControlName="{{modelo.menuSuperior}}" [label]="'Menú Nivel 1*'" [type]="'text'" [id]="'menu'">
                </app-lfsa-input>
            </div>
            <div class="col-md-3">
                <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get(modelo.orden)" [placeholder]="'Ingrese el orden del Menú nivel 1 '"
                    formControlName="{{modelo.orden}}" [label]="'Orden Nivel 1*'" [type]="'number'" [id]="'orden'">
                </app-lfsa-input>
            </div>
            <div class="col-md-3">
                <label>&nbsp;</label>
                <button [disabled]="formulario.invalid" class="{{diccionarioModulo.button.buttonsCss.success}}"
                    (click)="NuevoMenuNivel1()">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                    {{diccionarioModulo.button.buttonsNombre.agregar}}
                </button>
            </div>
        </div>
    </form>
    <ag-grid-angular [floatingFilter]="true" class="{{diccionarioModulo.agGrid.class}}" #agGrid
        [ngStyle]="diccionarioModulo.agGrid.style" id="{{diccionarioModulo.agGrid.id}}"
        [paginationPageSize]="$any(diccionarioModulo.agGrid).paginacion" [pagination]="true"
        [frameworkComponents]="frameworkComponents" [columnDefs]="columnDefs" [rowSelection]="rowSelection"
        [rowData]="rowData" (gridReady)="onGridReady($event)">
    </ag-grid-angular>
</ng-template>
